export const createSearchActions = ({
  requestHandler,
  metricHandler,
  semMetricHandler
}) => ({
  startMetric() {
    metricHandler.start();
  },
  startSemMetric() {
    semMetricHandler.start();
  },
  perform: requestHandler.perform
});